import Money from "../lib/Money";

/**
 * Transform one AAG/Canyonero cart item to GPC/Adobe format.
 *
 */
export function cartItemToAdobeCartItem(cartItem) {
  // googleSku - same sku format used in google shopping, like groupid-000000
  const fullSku = cartItem.googleSku || `${cartItem.productGroupId}-${cartItem.vendorsku}`;

  return {
    productID: fullSku,
    productHQID: cartItem.fullNapaSku || fullSku,
    quantity: cartItem.quantity,
    currency: "USD",
    sellingPrice: new Money(cartItem.effectiveUnitPrice).toDollars(),
    fulfillmentMethod: "bol",
    pickupEstimation: ""
  };

}

export function cartItemToAdobeProductInfo(cartItem, shoppingCart) {
  let fullSku = cartItem.googleSku || `${cartItem.productGroupId}-${cartItem.vendorsku}`;

  return  {
    productID: fullSku,
    currency: "USD",
    dcID: "",
    recommSourcePlacement: "", //"PDP:Belowproductdescription",
    recomSourceType: "",
    recommendationengine: "",
    recommendationRank: 0,
    cartAddType: "PDP",
    cartId: shoppingCart?.cartCode,
    parentProductID: "",
    sellingPrice: new Money(cartItem.effectiveUnitPrice).toDollars(),
    quantity: cartItem.quantity,
    fulfillmentMethod: "BOL",
    storePickupEnabled: "",
    shipToHome: "",
    imageAvailable: "Yes",
    isPromo: "No",
    plpImpressionRank: 0,
    productHQID: cartItem.fullNapaSku || fullSku,
    searchPlatform: ""
  }
}



/**
 * event.product = buildProductList({items, shoppingCart}
 *
 * @param items
 * @param shoppingCart
 * @returns {*}
 */
export function buildProductList({items, shoppingCart}) {
  // Note that each member of the list has a single .productInfo
  return items.map(cartItem => {
    let productInfo = cartItemToAdobeProductInfo(cartItem, shoppingCart)
    return {productInfo};
  });
}

export function buildCartItemsList({items, shoppingCart}) {
  return items.map(cartItem => {
    return cartItemToAdobeCartItem(cartItem, shoppingCart)
  });
}
